import { h } from "preact";
import { Input, Button, Select } from "antd";
import { PlusOutlined, ReloadOutlined, SearchOutlined } from "@ant-design/icons";

const { Option } = Select;

export const ConsumersSearch = ({
                                    searchText,
                                    onSearchChange,
                                    onRefresh,
                                    onNewConsumer,
                                    loading,
                                    statusFilter,
                                    onStatusFilterChange
                                }) => {
    return (
        <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px 24px",
            borderBottom: "1px solid #f0f0f0"
        }}>
            <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                <Input
                    placeholder="Search consumers"
                    value={searchText}
                    onChange={onSearchChange}
                    prefix={<SearchOutlined />}
                    style={{ width: 300 }}
                />
                <Select
                    value={statusFilter}
                    onChange={onStatusFilterChange}
                    style={{ width: 150 }}
                    placeholder="Filter by status"
                >
                    <Option value="all">All Status</Option>
                    <Option value="active">Active Only</Option>
                    <Option value="forbidden">Forbidden Only</Option>
                    <Option value="archived">Archived Only</Option>
                </Select>
            </div>

            <div style={{ display: "flex", gap: "8px" }}>
                <Button
                    icon={<ReloadOutlined />}
                    onClick={onRefresh}
                    loading={loading}
                >
                    Refresh
                </Button>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={onNewConsumer}
                    style={{ backgroundColor: "#52c41a", borderColor: "#52c41a" }}
                >
                    Create Consumer
                </Button>
            </div>
        </div>
    );
};